import { FC, useMemo } from 'react';
import { Grid, GridItem } from '../../grid';
import { CalendarProps } from '../types';
import './style.less';

export type WeekListProps = {
  weekType: CalendarProps['weekType'];
};

export const WeekList: FC<WeekListProps> = (props) => {
  const weekNameList = useMemo(() => {
    const tempList = [
      { label: '一', value: 1 },
      { label: '二', value: 2 },
      { label: '三', value: 3 },
      { label: '四', value: 4 },
      { label: '五', value: 5 },
      { label: '六', value: 6 },
    ];
    if (props.weekType === 'week7-first') {
      tempList.unshift({ label: '日', value: 7 });
    } else {
      tempList.push({ label: '日', value: 7 });
    }
    return tempList;
  }, [props.weekType]);
  return (
    <Grid columns={7} className="week-list" gap={0} columnHeight={50}>
      {weekNameList.map((item) => {
        return <GridItem key={item.value}>{item.label}</GridItem>;
      })}
    </Grid>
  );
};
